import {
  Button,
  Descriptions,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Typography,
  Spin,
  Row,
  Col,
  Progress,
  Upload,
  message,
} from "antd";
import { collection, doc, onSnapshot, query, serverTimestamp, updateDoc, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { FaPenToSquare } from "react-icons/fa6";
import { db, storage } from "../../../firebase/config";
import { UploadOutlined } from "@ant-design/icons";
import { ref, uploadBytesResumable } from "firebase/storage";

const { TextArea } = Input;

const { Title, Text } = Typography;

export default function UpdatePlate(props) {
  const { data, clientList } = props;
  const [open, setOpen] = useState(false);

  //technical page file
  const [filesList, setFilesList] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  //loading
  const [loading, setLoading] = useState(false);

  const [productList, setProductList] = useState([]);
  const [productListLoading, setProductListLoading] = useState(false);

  //init form
  const [form] = Form.useForm();

  //main data object
  const [dataObject, setDataObject] = useState({
    clientId: data.clientId,
    client: data.client,
    code: data.code,
    codeNumber: data.codeNumber,
    codePrefix: data.codePrefix,
    important: data.important,
    knifeNumber: data.knifeNumber,
    knifeCode: data.knifeCode,
    knifeRows: data.knifeRows,
    layoutDesign: data.layoutDesign,
    product: data.product,
    productId: data.productId,
    width: data.width,
    height: data.height,
    plateLocation: data.plateLocation,
    rows: data.rows,
    designerProductName: data.designerProductName,
    isMultiple: data.isMultiple,
  });

  //selects the current machine ref
  useEffect(() => {
    console.log(props.data);
  }, [props]);

  //gets products based on client
  useEffect(() => {
    if (open) {
      setProductListLoading(true);
      const ref = collection(db, "priceCalculation");
      let q = query(ref, where("clientId", "==", dataObject.clientId));

      const unsubscribe = onSnapshot(q, (snapshot) => {
        let results = [];
        snapshot.docs.forEach((doc) => {
          const data = doc.data();
          results.push({ ...data, key: doc.id, id: doc.id });
        });
        // sort the results based on the arsomaSequence state
        setProductList(results);
        setProductListLoading(false);
      });

      return () => unsubscribe();
    }
  }, [dataObject.clientId, open]);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        client: data.client,
        product: data.product,
        layoutDesign: data.layoutDesign,
        rows: data.rows,
        plateLocation: data.plateLocation,
        important: data.important,
        designerProductName: data.designerProductName,
      });
    }
  }, [open, data, form]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onFinish = (values) => {
    console.log("Success:", values);
    updatePlate();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  //adds the new plate
  const updatePlate = async () => {
    //updates the plate ref for data
    //plate ref is taken from plate object
    const plateRef = doc(db, data.plateRef, data.id);

    //checks product id
    let productNewId;
    if (data.productId === undefined) {
      productNewId = null;
    } else {
      productNewId = dataObject.productId;
    }

    //checks client id
    let clientNewId;
    if (data.clientId === undefined) {
      clientNewId = null;
    } else {
      clientNewId = dataObject.clientId;
    }

    try {
      setLoading(true);

      // Prepare all upload tasks
      const uploadPromises = filesList.map((file) => {
        //file path includes storage ref which is taken from plate object
        const filePath = `${data.storageRef}/${dataObject.code}/${file.name}`;
        const fileRef = ref(storage, filePath);
        const uploadTask = uploadBytesResumable(fileRef, file.originFileObj);

        return new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setUploadProgress((prev) => ({ ...prev, [file.uid]: progress }));
            },
            (error) => {
              console.error("Error uploading file", file.name, error);
              message.error(`Failed to upload ${file.name}.`);
              reject(error);
            },
            () => {
              setUploadProgress((prev) => ({ ...prev, [file.uid]: 100 }));
              resolve();
            }
          );
        });
      });

      // Wait for all uploads to complete
      await Promise.all(uploadPromises);

      await updateDoc(plateRef, {
        client: dataObject.client,
        product: dataObject.product,
        productId: productNewId,
        clientId: clientNewId,
        plateLocation: dataObject.plateLocation,
        layoutDesign: dataObject.layoutDesign,
        rows: dataObject.rows,
        important: dataObject.important,
        designerProductName: dataObject.designerProductName,
        codePrefix: "POLI",
        updated: serverTimestamp(),
      });
    } catch (error) {
      message.error(error.message);
    } finally {
      message.success("Updated plate!");
      setLoading(false);
      setFilesList([]);
      setOpen(false);
      form.resetFields();
    }
  };

  //handle select for client
  const handleClientSelect = (value, option) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      client: option.client,
      clientId: option.id,
    }));
    form.resetFields(["product"]);
  };

  //handle select for product
  const handleProductSelect = (value, option) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      product: value,
      productId: option.id,
    }));
  };

  //handles layout name
  const handleLayoutName = (event) => {
    const value = event.target.value;
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      layoutDesign: value,
    }));
  };

  //handles plate rows
  const handlePlateRows = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      rows: value,
    }));
  };

  //handle comment
  const handleComment = (event) => {
    const value = event.target.value;
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      important: value,
    }));
  };

  //handle designer name
  const handleDesignerName = (event) => {
    const value = event.target.value;
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      designerProductName: value,
    }));
  };

  //handles plate location
  const handlePlateLocation = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      plateLocation: value,
    }));
  };

  //handles fileChange
  const handleFileChange = (info) => {
    let fileList = [...info.fileList];
    setFilesList(fileList);
  };

  //returns uploading state
  const returnLoadingState = () => {
    if (loading) {
      return (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255,255,255,0.9)", // white with 50% opacity
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 15,
          }}
        >
          <div>
            <Row>
              <Col span={24}>
                <Title>
                  <Spin /> Files being uploaded
                </Title>
              </Col>
            </Row>

            {filesList &&
              filesList.map((file) => (
                <div key={file.uid}>
                  <Text italic>{file.name}</Text>
                  <Progress percent={uploadProgress[file.uid] || 0} />
                </div>
              ))}
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <FaPenToSquare onClick={showDrawer} />
      <Drawer title={data.code} placement="left" onClose={onClose} open={open}>
        {returnLoadingState()}
        <Form
          form={form}
          name={data.id}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          labelCol={{
            span: 24,
          }}
          style={{ width: "100%" }}
        >
          <Form.Item
            label="Select client"
            name="client"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select client"
              optionFilterProp="children"
              onChange={handleClientSelect}
              fieldNames={{ label: "client", value: "id", key: "id" }}
              filterOption={(input, option) => (option?.client ?? "").toLowerCase().includes(input.toLowerCase())}
              options={clientList && clientList}
            />
          </Form.Item>

          <Form.Item
            label="Select product"
            name="product"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select product"
              optionFilterProp="children"
              onChange={handleProductSelect}
              loading={productListLoading}
              filterOption={(input, option) => (option?.product?.productName ?? "").toLowerCase().includes(input.toLowerCase())}
              options={
                productList &&
                productList.map((option, index) => ({
                  label: option?.product?.productName,
                  value: option?.product?.productName,
                  key: index,
                  id: option.id,
                }))
              }
            />
          </Form.Item>
          <Form.Item
            label="Plate Location"
            name="plateLocation"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}
          >
            <Select
              onChange={handlePlateLocation}
              options={[
                {
                  value: "Not Ordered",
                  label: "Not Ordered",
                },
                {
                  value: "Ordered",
                  label: "Ordered (in proccess)",
                },
                {
                  value: "Kengarags",
                  label: "At Kengarags",
                },
                {
                  value: "Visvaldis",
                  label: "At Visvaldis",
                },
              ]}
            />
          </Form.Item>

          <Form.Item
            label="Layout Name"
            name="layoutDesign"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}
          >
            <Input style={{ width: "100%" }} onChange={handleLayoutName} />
          </Form.Item>

          <Form.Item
            label="Plate rows"
            name="rows"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} min={0} max={100} onChange={handlePlateRows} />
          </Form.Item>

          <Form.Item
            label="Important"
            name="important"
            rules={[
              {
                message: "Please input your field!",
              },
            ]}
          >
            <TextArea rows={4} style={{ width: "100%" }} onChange={handleComment} />
          </Form.Item>
          <Form.Item label="Designer product name (optional)" name="designerProductName">
            <Input placeholder="Write your own product slogan" style={{ width: "100%" }} onChange={handleDesignerName} />
          </Form.Item>

          <Form.Item label="Add extra files to the plate folder" name="filesList">
            <Upload
              beforeUpload={() => false} // Prevent the default upload behavior
              multiple={true}
              fileList={filesList}
              onChange={handleFileChange}
            >
              <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
          </Form.Item>

          <Form.Item>
            <Button block type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
        {/* <List
          size="small"
          dataSource={data.plateFiles}
          renderItem={(item) => (
            <List.Item>
              <Text mark> {item.fileUrl}</Text>
            </List.Item>
          )}
        /> */}
        <Descriptions column={1} title="Extra values">
          <Descriptions.Item label="multiple?">{data.isMultiple ? "yes" : "no"}</Descriptions.Item>
          <Descriptions.Item label="width X height">{data.widthXHeight}</Descriptions.Item>
          <Descriptions.Item label="code">{data.code}</Descriptions.Item>
          <Descriptions.Item label="knife number">{data.code}</Descriptions.Item>
          <Descriptions.Item label="machine">{data.machine}</Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  );
}
